export const en = {
  joinNewsletter:
    "Join our newsletter to stay up to date on features and releases",
};
